import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Paper,
} from "@mui/material";

import AddressForm from "./AddressForm";
import AppoinmentBookingInfo from "./AppoinmentBookingInfo";
import { ProfileForm } from "./ProfileForm";
import {
  bookHomeCollection,
  checkValidAppointment,
  registeredPatient,
} from "../../api/api";
import {
  convertToMMDDYYYY,
  formatDate,
  formatDobDisplay,
  toBase64Raw,
} from "../../utils/helper";
import toast from "react-hot-toast";
import { useCart } from "../../Contexts/Cart.contexts";
import { getUserData, getUserMobile } from "../../utils/auth";
import { useFormik } from "formik";
import * as Yup from "yup";
import HomeCollectionSummaryModal from "./HomeCollectionSummaryModal";
import HomeCollectionSuccessModal from "./HomeCollectionSuccessModal";
import CustomLoader from "../../common/loader/CustomLoader";

const steps = ["Patient Info", "Address Info", "Booking Info "];

export default function HomeAppoinmentForm() {
  const isLoggedin = Boolean(getUserData());
  const mobileNo = getUserMobile();
  const [activeStep, setActiveStep] = useState(0);
  const [formValid, setFormValid] = useState(true);
  const [patientType, setPatientType] = useState("new");
  const [loading, setLoading] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [sucess, setSuccess] = React.useState(false);
  const [bookingDetails, setBookingDetails] = useState({});

  const [isOtpVerified, setIsOtpverified] = useState(false);

  const [showPatientType, setShowPatientType] = useState(isLoggedin);
  const [selectedPatient, setSelectedPatient] = useState("");
  const [showVerification, setShowVerification] = useState(!isLoggedin);
  const [profileData, setProfileData] = useState([]);
  const [allFieldsTouched, setAllFieldsTouched] = useState(false);
  const { cartItems, clearCart } = useCart();
  const [currentLocation, setCurrentLocation] = useState({
    lat: 22.5754,
    lng: 88.4791,
    selected: false,
  });
  const [formData, setFormData] = useState({
    user_id: "",
    mobile_no: isLoggedin ? mobileNo : "",
    Alt_mobile_no: "",
    PFirstName: "",
    PLastName: "",
    email: "",
    dateofbirth: "",
    PSex: "M",
    address: "",
    City: "",
    landmark: "",
    State: "West Bengal",
    Zipcode: "",
    preferredDate: "",
    preferredTime: "",
    Rtime: "",
    APPToTime: "",
    prescription: "",
    latitude: "",
    longitude: "",
    ref_doctorID: "",
    ref_doctor: "",
    regNo: "",
    specialization: "",
  });

  const goToProfileForm = () => setActiveStep(0);
  const goToAddressForm = () => setActiveStep(1);
  const handleNext = () => {
    // If current step is invalid, show all validation errors
    if (!formValid) {
      setAllFieldsTouched(true);
      toast.error("Please fill all required fields");
      return;
    }
    // Reset allFieldsTouched for next step
    setAllFieldsTouched(false);
    setActiveStep((prev) => prev + 1);
  };
  const handleBack = () => setActiveStep((prev) => prev - 1);
  const handleReset = () => setActiveStep(0);
  const totalPrice = String(
    cartItems.reduce((sum, item) => sum + (Number(item.price) || 0), 0)
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  console.log("Form Data:", formData);

  const StepComponents = [
    <ProfileForm
      formData={formData}
      setFormData={setFormData}
      onNext={handleNext}
      setFormValid={setFormValid}
      setPatientType={setPatientType}
      patientType={patientType}
      showVerification={showVerification}
      setShowVerification={setShowVerification}
      showOtp={showOtp}
      setShowOtp={setShowOtp}
      selectedPatient={selectedPatient}
      setSelectedPatient={setSelectedPatient}
      isOtpVerified={isOtpVerified}
      setIsOtpverified={setIsOtpverified}
      showPatientType={showPatientType}
      setShowPatientType={setShowPatientType}
      profileData={profileData}
      setProfileData={setProfileData}
      handleChange={handleChange}
      allFieldsTouched={allFieldsTouched}
      setAllFieldsTouched={setAllFieldsTouched}
    />,
    <AddressForm
      formData={formData}
      setFormData={setFormData}
      onNext={handleNext}
      setFormValid={setFormValid}
      onEditProfile={goToProfileForm}
      handleChange={handleChange}
      allFieldsTouched={allFieldsTouched}
      setAllFieldsTouched={setAllFieldsTouched}
      currentLocation={currentLocation}
      setCurrentLocation={setCurrentLocation}
    />,
    <AppoinmentBookingInfo
      formData={formData}
      setFormData={setFormData}
      onNext={handleNext}
      setFormValid={setFormValid}
      onEditProfile={goToProfileForm}
      onEditAddress={goToAddressForm}
      allFieldsTouched={allFieldsTouched}
      setAllFieldsTouched={setAllFieldsTouched}
    />,
  ];

  const handleCheckAppointment = async () => {
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      mobile_no: formData?.mobile_no,
      RDate: formatDate(formData?.preferredDate),
    };

    try {
      const res = await checkValidAppointment(payload);
      console.log("Check Appointment Response:", res);
      if (res?.data?.status === "success") {
        // toast.success("Home Collection Appointment is Possible.");
        return true;
      } else {
        toast.error(`Already ${res?.data?.message} on this num`);

        return false;
      }
    } catch (error) {
      toast.error("Error checking appointment.");
      return false;
    }
  };

  const handleRegisteredPatient = async () => {
    const current = new Date();
    const pad = (n) => n.toString().padStart(2, "0");
    const date = `${pad(current.getDate())}-${pad(
      current.getMonth() + 1
    )}-${current.getFullYear()}`;
    // console.log("Current Date:", date);
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      user_id: "",
      FName: formData?.PFirstName,
      LName: formData?.PLastName,
      Email: formData?.email,
      Mobile_no: formData?.mobile_no,
      Alt_mobile_no: formData?.Alt_mobile_no,
      Address: formData?.address,
      Landmark: formData?.landmark,
      ZipCode: formData?.Zipcode,
      City: formData?.City,
      State: formData?.State,
      Reg_status: "0",
      Pat_status: "0",
      IsMobileregister: "Y",
      Registerdate: date,
      Gender: formData?.PSex,
      PTitle: formData?.PSex === "M" ? "Mr" : "Mrs",
      Dateofbirth: formatDobDisplay(formData?.dateofbirth),
    };
    // console.log("Payload for Registered Patient:", payload);
    try {
      setLoading(true);
      const res = await registeredPatient(payload);
      console.log("Registered Patient Response:", res);
      if (res?.data?.status === "success") {
        // setNewPatientId(res?.data?.data?.user_id || "");

        toast.success("Patient registered successfully.");
        return res?.data?.user_id || "";
      }
    } catch (error) {
      toast.error(error?.data?.message || "something went wrong");
    }
  };

  const handleBookHomeCollection = async (userId) => {
    let presImgBase64 = "";

    if (formData?.prescription) {
      presImgBase64 = await toBase64Raw(formData.prescription);
    }
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      user_id: userId,
      Gender: formData?.PSex,
      PTitle: formData?.PSex === "M" ? "Mr" : "Mrs",
      FName: formData?.PFirstName,
      LName: formData?.PLastName,
      Dateofbirth: formatDobDisplay(formData?.dateofbirth),
      Email: formData?.email,
      Mobile_no: formData?.mobile_no,
      Alt_mobile_no: formData?.Alt_mobile_no,
      Address: formData?.address,
      Landmark: formData?.landmark,
      ZipCode: formData?.Zipcode,
      City: formData?.City,
      State: formData?.State,
      Rdate: formatDate(formData?.preferredDate),
      Rtime: formData?.Rtime,
      APPToTime: formData?.APPToTime,
      longitude: formData?.longitude || "",
      latitude: formData?.latitude || "",
      // ref_doctor: formData?.ref_doctor || "",
      // ref_doctorID: formData?.ref_doctorID || "",
      total_price: String(totalPrice),
      services_list: cartItems.map((item) => String(item.id)).join(",") || [],
      PrescImage: presImgBase64 || "",
      Center_ID: "1",
      COVIDSample: "N",
      Status: "B",
      appointment_id: "0",
      CollectorNote: "",
      Channel: "W",
      BookedBy: "Patient",
      comments: "",
    };
    if (formData?.ref_doctorID) {
      payload.ref_doctorID = formData.ref_doctorID;
      payload.ref_doctor = formData.ref_doctor;
    }

    console.log("Payload for Book Home Collection:", payload);

    try {
      setLoading(true);
      const res = await bookHomeCollection(payload);
      console.log("Book Home Collection Response:", res);
      if (res?.data?.status === "success") {
        toast.success("Home Collection booked successfully.");
        setBookingDetails({
          ...formData,
          appointment_id: res?.data?.appointment_id || "",
        });
        setSuccess(true);
      } else {
        toast.error("Failed to book Home Collection.");
      }
    } catch (error) {
      toast.error("Error booking Home Collection.");
    } finally {
      setLoading(false);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const isValid = await handleCheckAppointment();
  //   if (!isValid) {
  //     return;
  //   }
  //   if (patientType === "new") {
  //     const newUserId = await handleRegisteredPatient();
  //     if (!newUserId) return;
  //     await handleBookHomeCollection(newUserId);
  //   } else if (patientType === "existing") {
  //     await handleBookHomeCollection(formData?.user_id);
  //   }
  // };

  const handleSubmit = async (e) => {
    setOpen(false);
    e.preventDefault();

    // 🚨 If form is not valid, stop submission
    if (!formValid) {
      setAllFieldsTouched(true); // <-- triggers all error messages
      toast.error("Please fill all required fields");
      return;
    }

    const isValid = await handleCheckAppointment();
    if (!isValid) return;

    if (patientType === "new") {
      const newUserId = await handleRegisteredPatient();
      if (!newUserId) return;
      await handleBookHomeCollection(newUserId);
    } else if (patientType === "existing") {
      await handleBookHomeCollection(formData?.user_id);
    }
  };

  const confirmSubmission = () => {
    if (!formValid) {
      setAllFieldsTouched(true);
      toast.error("Please fill all required fields");
      return;
    }

    setOpen(true);
  };

  const handleSuccessClose = () => {
    clearCart();
    setSuccess(false);

    // reset stepper to first step
    setActiveStep(0);

    // reset form data
    setFormData({
      user_id: "",
      mobile_no: isLoggedin ? mobileNo : "",
      Alt_mobile_no: "",
      PFirstName: "",
      PLastName: "",
      email: "",
      dateofbirth: "",
      PSex: "M",
      address: "",
      City: "",
      landmark: "",
      State: "West Bengal",
      Zipcode: "",
      preferredDate: "",
      preferredTime: "",
      Rtime: "",
      APPToTime: "",
      prescription: "",
      latitude: "",
      longitude: "",
      ref_doctorID: "",
      ref_doctor: "",
      regNo: "",
      specialization: "",
    });

    // reset validation / OTP / flags
    setAllFieldsTouched(false);
    setIsOtpverified(false);
    setShowOtp(false);
    setShowVerification(false);
    setShowPatientType(false);
    setSelectedPatient("");
    setPatientType("");

    // clear booking details if needed
    setBookingDetails(null);
  };

  return (
    <>
      {loading && <CustomLoader />}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          mt: 2,
        }}
      >
        <Paper
          elevation={2}
          sx={{
            width: "100%",
            mx: 2,
            //   maxWidth: 700,
            p: 1.5,
            borderRadius: 3,
            backgroundColor: "#f4f9fc",
          }}
        >
          <div className="stepperAndForm">
            {/* Stepper */}
            <Stepper
              activeStep={activeStep}
              alternativeLabel
              sx={{
                mb: 1,
                "& .MuiStepIcon-root.Mui-active": { color: "#20b2aa" }, // sea green
                "& .MuiStepIcon-root.Mui-completed": { color: "#20b2aa" },
                "& .MuiStepLabel-label.Mui-active": {
                  fontWeight: "bold",
                  color: "#00796b",
                },
              }}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            {/* Step Content */}
            <Box sx={{ minHeight: 250 }}>
              {activeStep === steps.length ? (
                <Typography align="center" variant="h6">
                  🎉 All steps completed!
                </Typography>
              ) : (
                StepComponents[activeStep]
              )}
            </Box>

            {/* Buttons */}
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              {/* <Button
            disabled={activeStep === 0}
            onClick={handleBack}
            variant="outlined"
            sx={{
              borderColor: "#20b2aa",
              color: "#20b2aa",
              "&:hover": { borderColor: "#1e9d93", backgroundColor: "#e6f9f8" },
            }}
          >
            Back
          </Button> */}
              <Button
                disabled={activeStep === 0}
                onClick={handleBack}
                variant="outlined"
                sx={{
                  px: 4,
                  py: 1.2,
                  fontSize: "1rem",
                  borderWidth: 2,
                  borderColor: "#20b2aa",
                  color: "#20b2aa",
                  borderRadius: "10px",
                  textTransform: "none",
                  "&:hover": {
                    borderColor: "#1e9d93",
                    backgroundColor: "#e6f9f8",
                  },
                }}
              >
                BACK
              </Button>
              {activeStep === steps.length ? (
                <Button
                  onClick={handleReset}
                  variant="contained"
                  sx={{
                    backgroundColor: "#20b2aa",
                    "&:hover": { backgroundColor: "#1e9d93" },
                  }}
                >
                  Reset
                </Button>
              ) : (
                // <Button
                //   onClick={
                //     activeStep === steps.length - 1 ? handleSubmit : handleNext
                //   }
                //   variant="contained"
                //   disabled={!formValid}
                //   sx={{
                //     backgroundColor: formValid ? "#20b2aa" : "#9e9e9e",
                //     "&:hover": formValid ? { backgroundColor: "#1e9d93" } : {},
                //   }}
                // >
                //   {activeStep === steps.length - 1 ? "Submit" : "Next"}
                // </Button>
                <Button
                  onClick={
                    activeStep === steps.length - 1
                      ? confirmSubmission
                      : handleNext
                  }
                  variant="contained"
                  // disabled={!formValid}
                  sx={{
                    px: 4, // increase horizontal padding for larger button
                    py: 1.3, // increase vertical padding
                    fontSize: "1rem",
                    borderRadius: 2,
                    backgroundColor: "#20b2aa",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: formValid ? "#1e9d93" : "#20b2aa",
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#20b2aa", // same color when disabled
                      color: "#fff",
                      opacity: 0.6,
                      cursor: "not-allowed",
                      pointerEvents: "auto", // ensures hover works even when disabled
                      "&:hover": {
                        backgroundColor: "#20b2aa",
                        cursor: "not-allowed",
                      },
                    },
                  }}
                >
                  {activeStep === steps.length - 1 ? "Submit" : "Next"}
                </Button>
              )}
            </Box>
          </div>
        </Paper>

        <HomeCollectionSummaryModal
          open={open}
          onClose={() => setOpen(false)}
          onBook={handleSubmit}
          details={{
            ...formData,
            testName: cartItems.map((item) => item.product).join(", "),
            totalPrice: cartItems.reduce(
              (sum, item) => sum + (Number(item.price) || 0),
              0
            ),
          }}
        />
        <HomeCollectionSuccessModal
          open={sucess}
          onClose={handleSuccessClose}
          successDetails={bookingDetails}
        />
      </Box>
    </>
  );
}
